import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import TermsPolicyView from '../components/TermsPolicyView';
import {
  CUSTOMER_POLICY_PAGES,
  CUSTOMER_POLICY_ROUTES,
  CUSTOMER_SUPPORT,
} from '../data/customerPolicies';
import '../styles/DriverLegal.css';

const CustomerPolicyPage = ({ policyKey }) => {
  const page = CUSTOMER_POLICY_PAGES.find((item) => item.key === policyKey);
  if (!page) return null;

  const related = CUSTOMER_POLICY_PAGES.filter((item) => item.key !== policyKey);

  if (policyKey === 'terms') {
    return <TermsPolicyView page={page} related={related} />;
  }

  return (
    <main className="driver-legal-page">
      <SeoHead
        title={page.title}
        description={page.description}
        path={page.path}
      />

      <section className="page-banner block-space text-white" style={{ backgroundColor: 'var(--secondary-color)' }}>
        <div className="container">
          <h1 className="display-4 fw-bold">{page.heading}</h1>
          <p className="lead mb-0">
            Customer policy for EasyDropTaxi website and Customer App bookings.
          </p>
        </div>
      </section>

      <section className="block-space">
        <div className="container">
          <div className="driver-legal-content">
            <p><strong>Last updated:</strong> {page.lastUpdated}</p>

            {page.sections.map((section) => (
              <section key={section.heading}>
                <h2>{section.heading}</h2>
                {(section.paragraphs || []).map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                {section.list ? (
                  <ul>
                    {section.list.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                ) : null}
              </section>
            ))}

            <div className="driver-contact-panel">
              <p>
                <strong>Email:</strong>{' '}
                <a href={CUSTOMER_SUPPORT.mailto}>{CUSTOMER_SUPPORT.email}</a>
              </p>
              <p className="mb-0">
                <strong>Phone:</strong>{' '}
                <a href={CUSTOMER_SUPPORT.phoneTel}>{CUSTOMER_SUPPORT.phoneDisplay}</a>
              </p>
            </div>

            <h2>Other customer policies</h2>
            <ul>
              {related.map((item) => (
                <li key={item.path}>
                  <Link to={item.path}>{item.heading}</Link>
                </li>
              ))}
              <li>
                <Link to={CUSTOMER_POLICY_ROUTES.accountDeletion}>
                  Customer Account &amp; Data Deletion
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CustomerPolicyPage;
